import { webAPI } from '../../../axiosInstance';


const getAllTags = async () => {
  const response = await webAPI.get('/tags');
  return response.data;
};

// const addOffer = async (data: any) => {
//   console.log('data2333', data)
//   const response = await webAPI.post('/tags/deletetag', data, {
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   });
//   return response.data;
// };

const deleteTags = async (data: any) => {
  const response = await webAPI.delete(`/tags/deletetag/${data}`);
  return response.data;
};

export { getAllTags, deleteTags };
